import { useEffect, useState } from 'react';
import Content from '../AllPageContent/AllPageContent';
import Buttontabs from '../Buttontabs/Buttontabs';
import CurrentAffair from '../CurrentAffair/CurrentAffair';
import "../CurrentPage/Current.css";
import { fetchcuetdetails } from '../DynamicCourse/api';
import ImageComponent1 from '../ImageComponent/ImageComponent1';
import axios from 'axios';
import { BASE_URL } from '../../insightConfig/insightConfig';

function UGC_NET_Home() {
    const [contentToShow, setContentToShow] = useState('CUET');
    // const [news, setNews] = useState([]);
    const [cuetdetails, setcuetdetails] = useState('')
    const componentName = "ugc_net";
    // const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
               const response= await axios.get(BASE_URL+'/ugc/user/about');
               console.log(response.data);
                setcuetdetails(response?.data?.data[0]?.Description)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const paragraphs = cuetdetails || [];

    return (
        <>
            <div className='Cuet-background'>
                <div className='current-main-box'>
                    <h1>The National Eligibility Test (UGC-NET) »»</h1>
                    <Buttontabs componentName={componentName} setContentToShow={setContentToShow} />
                </div>
            </div>
            <div className='container-fluid cuet-width py-4'>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <Content paragraphs={paragraphs} />
                    </div>
                    {/* <div className='col-lg-4 card px-0 col-md-12 col-sm-12'>
                        <CurrentAffair componentName={componentName} />
                        <ImageComponent1 />
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default UGC_NET_Home;